/*
 * Liens externes (hors domaine) : ouverture en nouvel onglet site-wide.
 * Détection par hostname pour rester valable en dev/preview/live sans domaine hardcodé.
 * L'icône lien-externe du header est gérée en CSS pur (sections/header.liquid) :
 * le header est ré-hydraté par la Section Rendering API de Shopify, ce qui
 * effaçait toute icône injectée ici en JS (clignotement au chargement).
 */
(function () {
  function isExternal(link) {
    if (!link.hostname || link.hostname === window.location.hostname) return false;
    return link.protocol === 'http:' || link.protocol === 'https:';
  }

  function processLinks() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (!isExternal(link)) continue;
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processLinks);
  } else {
    processLinks();
  }

  // Le header (et d'autres sections) peuvent être ré-hydratés après le premier
  // rendu (Section Rendering API) : les attributs posés avant sont perdus si
  // on ne rejoue pas processLinks une fois le composant remplacé.
  var debounceId;
  new MutationObserver(function () {
    clearTimeout(debounceId);
    debounceId = setTimeout(processLinks, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
